import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.167.5A4.334 4.334 0 0 0 .833 4.833C.833 8.5 5.167 12.5 5.167 12.5S9.5 8.5 9.5 4.833A4.334 4.334 0 0 0 5.167.5m0 6.3a1.966 1.966 0 1 1 0-3.933 1.966 1.966 0 0 1 0 3.933"
    }, null, -1)
  ]))]))
}
export default { render: render }